import { render, staticRenderFns } from "./SortableTable.vue?vue&type=template&id=57ac74a6&scoped=true"
import script from "./SortableTable.vue?vue&type=script&lang=js"
export * from "./SortableTable.vue?vue&type=script&lang=js"
import style0 from "./SortableTable.vue?vue&type=style&index=0&id=57ac74a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac74a6",
  null
  
)

export default component.exports